"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import React from 'react';
import MainStore from 'Stores/MainStore';
import LoginForm from "Components/Login/LoginForm";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

var styles = function styles(theme) {
  return {
    root: theme.mixins.gutters({
      paddingTop: 16,
      paddingBottom: 16
    }),
    wrapper: {
      minHeight: '60%',
      justifyContent: 'center'
    },
    borderTop: {
      width: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      height: 6,
      background: theme.palette.primary.main
    },
    loginWrapper: {
      alignSelf: 'center',
      maxWidth: '350px',
      position: 'relative'
    }
  };
};

var LoginPage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginPage, _React$Component);

  function LoginPage(props) {
    var _this;

    _classCallCheck(this, LoginPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LoginPage).call(this, props));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = MainStore.getList();
    return _this;
  }

  _createClass(LoginPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      MainStore.addChangeListener(this._onChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      MainStore.removeChangeListener(this._onChange);
    }
  }, {
    key: "_onChange",
    value: function _onChange() {
      this.setState(MainStore.getList());
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return React.createElement(Grid, {
        container: true,
        spacing: 0,
        className: classes.wrapper
      }, React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.loginWrapper
      }, React.createElement(Paper, {
        className: classes.root
      }, React.createElement("div", {
        className: classes.borderTop
      }), React.createElement(LoginForm, null))));
    }
  }]);

  return LoginPage;
}(React.Component);

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withStyles(styles)(LoginPage);